























































import {
  defineComponent,
  ref,
  watch
} from '@nuxtjs/composition-api';
import {
  PropType
} from '@nuxtjs/composition-api';
import {
  ValidationProvider,
  ValidationObserver,
  extend
} from 'vee-validate';
import {
  SfInput,
  SfButton,
  SfTextarea
} from '@storefront-ui/vue';
import {
  required,
  email
} from 'vee-validate/dist/rules';
import {
  ContactFormFields
} from './types';

extend('email', {
  ...email,
  message: 'Invalid email',
});

extend('required', {
  ...required,
  message: 'This field is required',
});

export default defineComponent({
  name: 'ContactForm',
  components: {
    SfInput,
    SfButton,
    SfTextarea,
    ValidationObserver,
    ValidationProvider
  },
  props: {
    form: {
      type: Object as PropType < ContactFormFields > ,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    tag: {
      type: String,
      default: 'div',
    },
    content: {
      type: String,
      default: '',
    },
  },
  setup(props, {
    emit
  }) {
    const formCopy = ref < ContactFormFields > ({
      ...props.form
    });

    watch(
      () => props.form,
      (newForm) => {
        formCopy.value = {
          ...newForm
        };
      }, {
        immediate: true,
        deep: true
      }
    );

    const onSubmit = () => {
      emit('submit', formCopy.value);
    };

    return {
      formCopy,
      onSubmit,
    };
  },
});

